import React, { useState } from 'react'
import { Modal, Button, Form } from 'react-bootstrap';
import Highcharts from "highcharts/highstock";
import { insertTableBd } from '../../config/functions';

export const ModalCommentsOpt = ({ handleClose, xComentario, show, user, rig, recargarComentarios, theme }) => {

    const [comment, setComment] = useState('');
    
    // Aplicar tema por defecto si no se proporciona
    const currentTheme = theme || {
        bgColor: '#000000',
        fontColor: '#ffffff'
    };

    const handleSubmitComment = async () => {
        if (!comment.trim()) {
            return;
        }

        try {
            // 1. GUARDAR EN BD Y RECARGAR COMENTARIOS (esto es lo crítico)
            // ESPERAR a que termine antes de continuar
            await agregarComentarioEnBD();
            
            // 2. INTENTAR actualizar el gráfico (opcional)
            intentarActualizarGrafico();
            
            // 3. Dar tiempo para que React procese los cambios de estado
            // antes de cerrar el modal (300ms para asegurar re-render)
            await new Promise(resolve => setTimeout(resolve, 300));
            
            // 4. Limpiar y cerrar
            setComment('');
            handleClose();
            
        } catch (error) {
            console.error('Error al guardar comentario:', error);
            alert('Error al guardar el comentario. Por favor, intenta nuevamente.');
        }
    };

    const agregarComentarioEnBD = async () => {
        const date = new Date(xComentario.x);
        const fecha = new Date();
        const usuario = user;

        const dataComentarioSend = {
            nb_tldro_idn: rig,
            nb_var_idn: parseInt(xComentario.varIdn),
            dt_com_fch: date.toISOString(),
            nb_com_prof: 0,
            nb_com_val: comment,
            vr_adt_usureg: usuario,
            dt_adt_fchreg: fecha.toISOString(),
        };

        await insertTableBd('createComment', dataComentarioSend);
        
        // Recargar comentarios para que aparezcan sin recargar página
        if (recargarComentarios) {
            await recargarComentarios();
        }
    };

    const intentarActualizarGrafico = () => {
        const charts = Highcharts.charts.filter(
            chart => chart && chart.options && chart.options.chart && 
                    chart.options.chart.isReal === true && chart !== undefined
        );
        
        const flagsChart = charts.find(chart => {
            return chart.series && chart.series.some(series => series.type === 'scatter');
        });

        if (flagsChart) {
            agregarComentarioAlGrafico(flagsChart);
        }
    };

    const agregarComentarioAlGrafico = (chart) => {
        const usuario = user;
        const flagsSeries = chart.series.find(series => series.type === 'scatter');
        
        if (flagsSeries) {
            const point = {
                x: xComentario.x,
                y: 0,
                comment: comment,
                user: usuario,
            };
            
            flagsSeries.addPoint(point, true);
        }
    };

    return (
        <Modal 
            show={show} 
            onHide={handleClose}
            dialogClassName="modal-themed-dialog"
        >

            <Modal.Header closeButton>
                <Modal.Title>Agregar Comentario</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <Form>
                    <Form.Group>
                        <Form.Label>Comentario</Form.Label>
                        <Form.Control
                            type="text"
                            value={comment}
                            onChange={e => setComment(e.target.value)}
                            placeholder="Ingrese su comentario"
                        />
                    </Form.Group>
                </Form>
            </Modal.Body>

            <Modal.Footer>
                <Button variant="secondary"
                    onClick={handleClose}>
                    Cerrar
                </Button>
                <Button variant="primary"
                    onClick={() => handleSubmitComment()}>
                    Guardar Comentario
                </Button>
            </Modal.Footer>

        </Modal>
    )
}
